import { useEffect } from 'react'

import { useAuthStore } from '@/features/auth/stores/auth.store'
import socketService from '@/shared/socket/socket.service'

import { useMessagesStore } from '../stores/messages.store'

export const useMessageNotifications = () => {
  const userId = useAuthStore((state) => state.user?.id || state.user?._id)
  const role = useAuthStore((state) => state.user?.role)

  const addMessage = useMessagesStore((state) => state.addMessage)
  const updateMessageRead = useMessagesStore((state) => state.updateMessageRead)
  const fetchUnreadCounts = useMessagesStore((state) => state.fetchUnreadCounts)
  const markAsRead = useMessagesStore((state) => state.markAsRead)

  useEffect(() => {
    if (!userId) return undefined

    fetchUnreadCounts().catch((error) => {
      console.error('Failed to fetch message unread counts:', error)
    })

    const socket = socketService.connect()
    if (!socket) return undefined

    const handleNewMessage = (msg) => {
      console.log('📥 Socket received message:new', msg)
      addMessage(msg)

      const activePartner = useMessagesStore.getState().activePartner
      const activePartnerId = String(
        activePartner?._id || activePartner?.id || '',
      )
      const senderId = String(msg?.senderId || '')

      if (activePartnerId && activePartnerId === senderId) {
        // Chat is currently open with this sender, immediately mark as read
        markAsRead(senderId, activePartner?.role)
      } else {
        fetchUnreadCounts().catch(() => {})
      }
    }

    const handleSentMessage = (msg) => {
      console.log('📤 Socket received message:sent', msg)
      addMessage(msg)
    }

    const handleMessageRead = (data) => {
      console.log('👁️ Socket received message:read', data)
      updateMessageRead(data)
      fetchUnreadCounts().catch(() => {})
    }

    socket.on('message:new', handleNewMessage)
    socket.on('message:sent', handleSentMessage)
    socket.on('message:read', handleMessageRead)

    return () => {
      socket.off('message:new', handleNewMessage)
      socket.off('message:sent', handleSentMessage)
      socket.off('message:read', handleMessageRead)
    }
  }, [
    userId,
    role,
    addMessage,
    updateMessageRead,
    fetchUnreadCounts,
    markAsRead,
  ])
}
